// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/mf-uncontrolled.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/mf-uncontrolled/mf-uncontrolled.js';

mount([g0]);
